import store from '@/vuex/index';
import fetch from '../utils/fetch';
// 获取问券问题(包含提交页面gif图
export function surveyGetForAPP(data) {
  return fetch.get('/marketing/api/survey/getForAPP', data);
}
// 提交答案
export function surveyMemberCreateSurveyMemberInfoForAPP(data) {
  const url = store.getters.isLogin ? '/marketing/api/surveyMember/createSurveyMemberInfo' : '/marketing/api/surveyMember/createSurveyMemberInfoUnRequiredLogin';
  return fetch.post(url, data);
}
// 护肤档案页，解决方案页、APPS-产品推荐页（推荐商品和固定商品等信息）
export function surveyMemberGetSurveyMemberCommodityForAPP(data) {
  return fetch.get('/marketing/api/surveyMember/getSurveyMemberCommodityForAPP', data);
}
// 用户是否做过问卷
export function surveyMemberIsSurveyMember(data) {
  return fetch.post('/marketing/api/surveyMember/isSurveyMember', data);
}
// 一键加入购物车
export function surveyRecommendCommodityListToCart(data) {
  return fetch.post('/order/api/shoppingCart/surveyRecommendCommodityListToCart', data);
}
export function surveyRelationshipSurveyMember(data) {
  const { id, memberId } = data;
  return fetch.get(`/marketing/api/surveyMember/relationshipSurveyMember?id=${id}&memberId=${memberId}`);
}
